"use strict";
// Stremio Plus: the profile unlocked on this device.
// The core reads it once at startup (see createTransport and plus/worker.js),
// so switching profile reloads the app.
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProfileChosen = exports.isProfileChosen = exports.isUnlocked = exports.setActiveProfile = exports.getActiveProfile = exports.SWITCH_PROFILE_EVENT = void 0;
var ACTIVE_PROFILE_KEY = 'stremio_plus_active_profile';
var PROFILE_CHOSEN_KEY = 'stremio_plus_profile_chosen';
// Dispatched on window to open the profile picker (e.g. from the nav menu).
exports.SWITCH_PROFILE_EVENT = 'stremio-plus:switch-profile';
var getActiveProfile = function () {
    var _a;
    try {
        var value = JSON.parse((_a = localStorage.getItem(ACTIVE_PROFILE_KEY)) !== null && _a !== void 0 ? _a : 'null');
        return value !== null && typeof value.id === 'string' ? value : null;
    }
    catch (_b) {
        return null;
    }
};
exports.getActiveProfile = getActiveProfile;
var setActiveProfile = function (profile) {
    if (profile === null) {
        localStorage.removeItem(ACTIVE_PROFILE_KEY);
    }
    else {
        localStorage.setItem(ACTIVE_PROFILE_KEY, JSON.stringify(profile));
    }
};
exports.setActiveProfile = setActiveProfile;
var isUnlocked = function (profile) {
    return profile !== null && typeof profile.token === 'string' && new Date(profile.tokenExpiresAt).getTime() > Date.now();
};
exports.isUnlocked = isUnlocked;
// Like Netflix, the picker shows once per app session.
var isProfileChosen = function () {
    try {
        return sessionStorage.getItem(PROFILE_CHOSEN_KEY) === 'true';
    }
    catch (_a) {
        return false;
    }
};
exports.isProfileChosen = isProfileChosen;
var setProfileChosen = function (chosen) {
    try {
        if (chosen) {
            sessionStorage.setItem(PROFILE_CHOSEN_KEY, 'true');
        }
        else {
            sessionStorage.removeItem(PROFILE_CHOSEN_KEY);
        }
    }
    catch (error) {
        console.error('Stremio Plus:', error);
    }
};
exports.setProfileChosen = setProfileChosen;
